var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 720,
    fill: "#20603D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 540,
    fill: "#FAD201"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 360,
    fill: "#00A1DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(886.5,188.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    id: "q",
    fill: "#E5BE01",
    d: "M 116.10000,0.00000 L 35.69202,4.69894 112.14399,30.04889 33.25966,13.77660 100.54555,58.05000 28.56072,21.91541 82.09510,82.09510 21.91541,28.56072 58.05000,100.54555 13.77660,33.25966 30.04889,112.14399 4.69894,35.69202 0.00000,116.10000 -1,-1 z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q",
    transform: "scale(1,-1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "scale(-1,1)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 34.3,
    fill: "#E5BE01",
    stroke: "#00A1DE",
    strokeWidth: 3.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRw);
export default __webpack_public_path__ + "static/media/rw.6c7fb7c34ff6d533667473a2c273ff7c.svg";
export { ForwardRef as ReactComponent };